import { createFileRoute } from "@tanstack/react-router";
import { SupportInboxPage } from "../../../components/system/SupportInboxPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/insights/support")({
  beforeLoad: requireSuperAdmin(),
  validateSearch: (search: Record<string, unknown>) => ({
    ref: typeof search.ref === "string" && search.ref.trim() ? search.ref.trim() : undefined,
  }),
  component: SystemInsightsSupportRoute,
});

function SystemInsightsSupportRoute() {
  const { ref } = Route.useSearch();
  return <SupportInboxPage initialReference={ref} />;
}
